import GridContext from "../grid-context";
import React from "react";
import { faSearch } from "@fortawesome/free-solid-svg-icons/faSearch";
import { Field } from "formik";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Form, Formik } from "formik";
import { IProps } from "./table-filters.types";
import { SubmitOnChange } from "@edgetier/components";
import "./table-filters.scss";

/**
 * Filters for a table. This is a form that will automatically submit when the filters change.
 * @param props.children Children containing various filters.
 * @returns              Filter form.
 */
const TableFilter = ({ children }: IProps) => (
    <GridContext.Consumer>
        {({ filters, searchKeys, setFilters }) => (
            <Formik initialValues={filters} onSubmit={setFilters}>
                {() => (
                    <Form className="grid__filters" name="grid__filters-form">
                        {Array.isArray(searchKeys) && (
                            <div className="field field-inline">
                                <div className="field-inline__icon">
                                    <FontAwesomeIcon icon={faSearch} />
                                </div>
                                <Field
                                    autoComplete="off"
                                    autoFocus={true}
                                    name="search"
                                    placeholder="Search&hellip;"
                                    spellCheck={false}
                                    type="text"
                                />
                            </div>
                        )}

                        {children}

                        <SubmitOnChange />
                    </Form>
                )}
            </Formik>
        )}
    </GridContext.Consumer>
);

export default TableFilter;
